"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/** Base class for picker view components. */
var BaseCalendarView = /** @class */ (function (_super) {
    __extends(BaseCalendarView, _super);
    function BaseCalendarView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseCalendarView.prototype.componentDidMount = function () {
        if (this.props.onMount) {
            this.props.onMount(this.calendarNode);
        }
    };
    return BaseCalendarView;
}(React.Component));
exports.default = BaseCalendarView;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-calendar-react/dist/views/BaseCalendarView.js
// module id = 129
// module chunks = 0